import { concentrations as cct, lowSceneLevel } from '@/utils/dict';
import ctt from '@/utils/const';
import { extSensorValAndUnitToText } from './/util/index';
import { pidReduction } from '@/utils/deviceUtils/index';
import { isEmpty, isObject } from '@/utils/is';
import { arrify } from '@/utils/utils';

export default {
  data() {
    return {
      radPicInfo: {},
      badgeHidden: true,
      dataLength: 0,
      chartData: {
        CHART_LEFT: {
          deviceState: {
            type: 'sysMod',
            typeName: '设备状态',
            deviceTypes: [ctt.FCBR_100CFR]
          },
          smoke: {
            type: 'smokeMod',
            typeName: '烟雾浓度',
            deviceTypes: [ctt.FCBR_100CFR]
          },
          nuclear2: {
            type: 'nuclearMod',
            typeName: '核辐射',
            deviceTypes: [ctt.FCBR_100CFR]
          }
        },
        CHART_RIGHT: {
          tvoc4: {
            type: 'ecMod',
            typeName: '可燃气体',
            deviceTypes: [ctt.FCBR_100CFR]
          },
          tvoc3: {
            type: 'ecMod',
            typeName: '氯化氢/二氧化硫/一氧化碳/TVOC/苯系物',
            deviceTypes: [ctt.FCBR_100CFR]
          },
          cwa: {
            type: 'cwaMod',
            typeName: '化学战剂',
            deviceTypes: [ctt.FCBR_100CFR]
          }
        }
      },
      pidThreshold: 0
    };
  },
  methods: {
    whichRow(mod) {
      const res = this.tableData.filter(e => e.type === mod);
      return res.length > 1 ? res : res[0];
    },
    getVals(mods, params) {
      const { list } = params;

      const value = list.map(e => {
        if (e.format) return e.format(mods);

        const v = mods[e.mod][e.prop];

        return isObject(v) ? v.value : v;
      });

      return value.join('/');
    },
    updateDeviceStateAndSmoke(newVal) {
      const { sysMod, smokeMod, cwaMod } = newVal.mods;
      if (cwaMod) this.echartObj.deviceState.series[0].data[0].value = cwaMod.flow;
      if (sysMod) this.echartObj.deviceState.series[1].data[0].value = sysMod.mainTemp;
      if (sysMod) this.echartObj.deviceState.series[2].data[0].value = sysMod.mainHumidity;
      if (smokeMod && smokeMod.smokeFault === 1) {
        // 烟雾故障
        this.echartObj.deviceState.series[3].data[0].value = 2;
      } else if (cwaMod && cwaMod.htFault === 1) {
        this.echartObj.deviceState.series[3].data[0].value = 0;
      } else {
        this.echartObj.deviceState.series[3].data[0].value = 1;
      }
      // 烟雾浓度
      let risk = smokeMod && (smokeMod.alarmContent === '无' ? '正常' : smokeMod.alarmContent);

      let value;
      switch (risk) {
        case '正常':
          value = 1;
          break;
        case 'Warning':
        case '警告':
          value = 9;
          break;
        default:
          value = 0;
          risk = this.$t('正常');
          break;
      }

      if (this.echartObj.smoke && smokeMod) {
        this.echartObj.smoke.series.data[0].value = value;
        this.echartObj.smoke.series.data[0].trueValue = parseInt(smokeMod.smokeData);
        this.echartObj.smoke.series.data[0].risk = risk;
      }
    },
    updateTable(newVal) {
      // 更新表格
      const { sysMod, smokeMod, cwaMod, nuclearMod, ecMod } = newVal.mods;

      if (ecMod) {
        // const { hcl, so2, co, ch4, pid, ben } = ecMod;
        const ecModRow = arrify(this.whichRow('ecMod'));

        if (this.deviceType === ctt.FCBR_100CFR) {
          const ls = ['hcl', 'so2', 'co', 'ch4', 'pid', 'ben'];

          const val = {
            state: ecMod.state,
            runstate: ecMod.runstate,
            change: ecMod.trend,
            cur: extSensorValAndUnitToText(ecMod, ls, {
              sameUnit: false,
              hasWrap: true,
              customUnitDict: { ch4: '%LEL' }
            }),
            alarmContent: ecMod.alarmContent
          };

          Object.assign(ecModRow[0], val);
        }
      }
      if (smokeMod) {
        const {
          state: smoketState,
          runstate: smokers,
          trend: smokeTrend,
          smokeData,
          alarmContent: smokeAc
        } = smokeMod;
        let smokeModRow = this.whichRow('smokeMod');
        smokeModRow.cur = smokeData;
        smokeModRow.change = smokeTrend;
        smokeModRow.state = smoketState;
        smokeModRow.runstate = smokers;
        smokeModRow.alarmContent = smokeAc;
      }
      if (cwaMod) {
        const {
          state: cwaState,
          runstate: cwars,
          trend: cwaTrend,
          concentration,
          alarmContent: cwaAc
        } = cwaMod;
        let cwaModRow = this.whichRow('cwaMod');
        cwaModRow.cur = cct[concentration];
        cwaModRow.change = cwaTrend;
        cwaModRow.state = cwaState;
        cwaModRow.runstate = cwars;
        cwaModRow.alarmContent = cwaAc;
      }
      if (sysMod) {
        const {
          state: sysState,
          runstate: sysrs,
          trend: sysTrend,
          mainTemp,
          alarmContent: sysAc
        } = sysMod;
        let sysModRow = this.whichRow('sysMod');
        sysModRow.cur = `${mainTemp + '(℃)'}/${
          cwaMod ? cwaMod.flow + '(L/min)' : '-'
        }/${this.faultRes(smokeMod ? smokeMod.smokeFault : 0, cwaMod ? cwaMod.htFault : 0)}`;
        sysModRow.change = sysTrend;
        sysModRow.state = sysState;
        sysModRow.runstate = sysrs;
        sysModRow.alarmContent = sysAc;
      }
      if (nuclearMod) {
        const {
          state: nuclearState,
          runstate: nuclearrs,
          trend: nuclearTrend,
          radDose,
          alarmContent: nuclearAc,
          rg04Dto
        } = nuclearMod;

        let nuclearModRow = this.whichRow('nuclearMod');

        const alpha = Number(rg04Dto.alphaProbeValue).toFixed(2);
        const beta = Number(rg04Dto.betaProbeValue).toFixed(2);

        nuclearModRow.cur = `${radDose}(uSv/h)/${alpha}(bq/cm²)/${beta}(bq/cm²)`;
        nuclearModRow.change = nuclearTrend;
        nuclearModRow.state = nuclearState;
        nuclearModRow.runstate = nuclearrs;
        nuclearModRow.alarmContent = nuclearAc;
      }
    },
    updateEchart(newVal) {
      const { isHisDetail } = this;
      const { beginTime } = newVal;
      const { smokeMod, cwaMod, nuclearMod, ecMod } = newVal.mods;

      const { tvoc3, tvoc4, cwa, nuclear2, smokeAd } = this.echartObj;

      // 设备状态和烟雾
      if (!isHisDetail) {
        // 非历史预警详情的时候更新
        this.updateDeviceStateAndSmoke(newVal);
        this.dataLength++;

        if (this.dataLength >= ctt.REAL_DATA_LENGTH) {
          this.dataLength--;
          if (cwaMod) {
            cwa?.series[0].data.shift();
            cwa?.series[1].data.shift();
          }
          if (ecMod) {
            tvoc3?.series[0].data.shift();
            tvoc3?.series[1].data.shift();
            tvoc3?.series[2].data.shift();
            tvoc3?.series[3].data.shift();
            tvoc3?.series[4].data.shift();

            tvoc4?.series.data.shift();
          }

          if (nuclearMod) {
            nuclear2.series[0].data.shift();
            nuclear2.series[1].data.shift();
            nuclear2.series[2].data.shift();
          }
        }
      }

      if (ecMod) {
        if (!isEmpty(tvoc4)) {
          tvoc4.legend.show = false;

          tvoc4.series.data.push([beginTime, ecMod.ch4.value]);
        }

        if (!isEmpty(tvoc3)) {
          tvoc3.series[0].data.push([beginTime, ecMod.hcl.value]);
          tvoc3.series[1].data.push([beginTime, ecMod.so2.value]);
          tvoc3.series[2].data.push([beginTime, ecMod.co.value]);
          tvoc3.series[3].data.push([beginTime, ecMod.pid.value]);
          tvoc3.series[4].data.push([beginTime, ecMod.ben.value]);
        }
      }

      if (cwaMod) {
        // 化学战剂
        if (!isEmpty(cwa)) {
          cwa.series[0].data.push([beginTime, cwaMod.sccell1RData]);
          cwa.series[1].data.push([beginTime, cwaMod.sccell2RData]);
        }
      }

      if (nuclearMod) {
        if (
          !isEmpty(nuclear2) &&
          !isEmpty(nuclearMod.rg04Dto?.alphaProbeValue) &&
          !isEmpty(nuclearMod.rg04Dto?.betaProbeValue)
        ) {
          nuclear2.series[0].data.push([beginTime, nuclearMod.radDose]);
          nuclear2.series[1].data.push([beginTime, nuclearMod.rg04Dto.alphaProbeValue]);
          nuclear2.series[2].data.push([beginTime, nuclearMod.rg04Dto.betaProbeValue]);
        }
      }

      if (smokeMod && smokeAd) {
        smokeAd.series.data.push([beginTime, smokeMod.smokeData]);
      }
    },
    updateThreshold(newVal) {
      if (newVal.paramItems && !newVal.paramItems.length) return;
      // 获取当前使用场景的 pidThreshold 值
      const pidThreshold = newVal.paramItems.find(e => e.itemCode === 'pidThreshold');
      if (!pidThreshold) return;
      const pidThresholdValue = pidThreshold.value[lowSceneLevel[newVal.sceneCurrent]];
      const ptd = pidReduction(pidThresholdValue, 100);
      this.pidThreshold = ptd;
    }
  }
};
